import { render, staticRenderFns } from "./KeyThirty.vue?vue&type=template&id=763b2cb9&scoped=true&"
import script from "./KeyThirty.vue?vue&type=script&lang=js&"
export * from "./KeyThirty.vue?vue&type=script&lang=js&"
import style0 from "./KeyThirty.vue?vue&type=style&index=0&id=763b2cb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763b2cb9",
  null
  
)

export default component.exports